import {PureComponent} from 'react'
import {FieldArray, reduxForm} from 'redux-form'

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'

import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import CheckboxToggleList from "../../../../shared/components/Form/Field/CheckboxList.jsx"


export const name = 'FreelanceInterviewSectorsForm'

class FreelanceInterviewSectorsForm extends PureComponent {
  render() {
    return <div id={name}>
      <form autoComplete="off" onSubmit={this.props.handleSubmit}>
        <div className="row">
          <FieldArray
            id="secteurs"
            name="freelance.secteurs"
            component={CheckboxToggleList}
            customOnChange={this.props.handleSubmit}
          />
        </div>
        <input className="d-none" type="submit"/>
        <FormGlobalErrors className="mt-0" errors={this.props.error}/>
      </form>
      <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
    </div>
  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name)
})(FreelanceInterviewSectorsForm)
